<ng-container *ngIf="accounts$ | async as accounts">
    <div [formGroup]="accountForm" class="row gx-2">
        <!-- hide account if only one -->
        <div
            class="col-6"
            [ngClass]="allSelectorsVisible ? 'col-sm-4' : 'col-sm-6'"
            [hidden]="accounts.accounts.length === 1"
        >
            <mat-form-field appearance="fill">
                <mat-label>Account</mat-label>
                <mat-select formControlName="account">
                    <mat-option
                        *ngFor="let account of accounts.accounts"
                        [value]="account"
                    >
                        {{ account.accountDisplayName || account.accountClientAlias }}
                    </mat-option>
                </mat-select>
                <mat-hint>Account for transaction</mat-hint>
                <mat-error *ngIf="accountForm.controls.account as formControl">
                    <ng-container *ngIf="formControl.hasError('required')">
                        Select an account
                    </ng-container>
                </mat-error>
            </mat-form-field>
            <!--<sb-account-select formControlName="account"></sb-account-select>-->
        </div>
        <!-- hide payment account if only one -->
        <div
            class="col-6"
            [ngClass]="allSelectorsVisible ? 'col-sm-4' : 'col-sm-6'"
            [hidden]="accounts.paymentAccounts.length === 1 || !displayPaymentAccount"
        >
            <mat-form-field appearance="fill">
                <mat-label>Payment account</mat-label>
                <mat-select formControlName="paymentAccount">
                    <mat-option
                        *ngFor="let account of accounts.paymentAccounts"
                        [value]="account"
                    >
                        {{ account.accountDisplayName || account.accountClientAlias }}
                    </mat-option>
                </mat-select>
                <mat-hint>Account for payment</mat-hint>
                <mat-error *ngIf="accountForm.controls.paymentAccount as formControl">
                    <ng-container *ngIf="formControl.hasError('required')">
                        Select an account
                    </ng-container>
                </mat-error>
            </mat-form-field>
            <!--<sb-account-select
                label="Payment account"
                formControlName="paymentAccount"
            ></sb-account-select>-->
        </div>
        <!-- hide broker account if only one -->
        <div
            class="col-6"
            [ngClass]="allSelectorsVisible ? 'col-sm-4' : 'col-sm-6'"
            [hidden]="accounts.brokerAccounts.length < 2 || !useBrokerAccount"
        >
            <mat-form-field appearance="fill">
                <mat-label>Broker account</mat-label>
                <mat-select formControlName="brokerAccount">
                    <mat-option
                        *ngFor="let account of accounts.brokerAccounts"
                        [value]="account"
                    >
                        {{ account.accountDisplayName || account.accountClientAlias }}
                    </mat-option>
                </mat-select>
                <mat-hint>Broker in transaction</mat-hint>
                <mat-error *ngIf="accountForm.controls.brokerAccount as formControl">
                    <ng-container *ngIf="formControl.hasError('required')">
                        Select an account
                    </ng-container>
                </mat-error>
            </mat-form-field>
            <!--<sb-account-select
                label="Broker account"
                formControlName="paymentAccount"
            ></sb-account-select>-->
        </div>
    </div>
</ng-container>
